import React from 'react';
import { TriggerProps, useFaContent } from 'src/feature-app';
import { LeadActionTrigger } from './LeadActionTrigger';
import { LeadBonoTrigger } from './LeadBonoTrigger';
import { LeadMatchTrigger } from './LeadMatchTrigger';
import { LeadOfertasTrigger } from './LeadOfertasTrigger';
import { LeadStockTrigger } from './LeadStockTrigger';
import { GTI50LeadTrigger } from './adhoc/GTI50LeadTrigger';

export function LeadEmbededTrigger(props: TriggerProps) {
	const { featureApp, action } = useFaContent();
	const { setSelectedJourney } = props;

	if (featureApp === 'es-ofertas') {
		return <LeadOfertasTrigger {...props} />;
	} else if (featureApp === 'es-stock-teaser') {
		return <LeadStockTrigger {...props} />;
	} else if (featureApp === 'es-match') {
		return <LeadMatchTrigger {...props} />;
	} else if (featureApp === 'es-bono') {
		return <LeadBonoTrigger {...props} />;
	} else if (featureApp === 'es-gti-50') {
		return <GTI50LeadTrigger />;
	} else if (featureApp === 'action') {
		return (
			<LeadActionTrigger
				setSelectedJourney={setSelectedJourney}
				action={action}
			/>
		);
	}

	return null;
}
